<template>
    <div class="card mb-25 border-0 rounded-0 bg-white create-role-box">
      <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing">
        <form @submit.prevent="createTaskType">
          <div class="row">
            <div class="col-md-12">
              <div class="form-group mb-15 mb-sm-20 mb-md-25">
                <label class="d-block text-black fw-semibold mb-10">
                  Task Name
                </label>
                <input
                  v-model="taskName"
                  type="text"
                  class="form-control shadow-none rounded-0 text-black"
                  placeholder="e.g. Administrator"
                  required
                />
              </div>
            </div>
            <div class="col-md-12">
              <button
                class="default-btn transition border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16 bg-success"
                type="submit"
              >
                Create Task Type
              </button>

              <button @click="goToMainMenu" class="default-btn transition border-0 fw-medium text-white 
                pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 
                fs-md-15 fs-lg-16 m-5 bg-danger" type="button"> Cancel </button>
                </div>
          </div>
        </form>
      </div>
    </div>
  </template>
  
  <script>
  import { defineComponent, ref } from "vue";
  import { AddTaskType } from '@/core/services/entities/task.service'
  import { useRouter } from "vue-router";
  import { useToast } from 'vue-toastification'
  
  export default defineComponent({
    name: "CreateTaskType",
    
    setup() {
      const taskName = ref("");

      const router = useRouter();

      const goToMainMenu = async () => {
        router.push({ name: "TaskTypeListPage" });
      };

      const createTaskType = async () => {
        const toast = useToast();
        const payload = { taskName: taskName.value };
        
        try {
                let response = await AddTaskType(payload);  
                if (response.status === 200) {
                  toast.success('Task Type added successfully!', {
                    timeout: 2000,
                  });
                  goToMainMenu();
                }
              } catch (ex) {
                const errorMessage = ex.response?.data || ex.message || "An unknown error occurred";
                toast.error(`Failed to added task type: ${errorMessage}`, {
                  timeout: 2000,
                });
              }

      };
  
      return {
        taskName,
        createTaskType,
        goToMainMenu
      };
    },
  });
  </script>
  